/* The reserved ids of the "derived" Build Your Own metrics — figures computed
   from data the app already holds (hooks/useDerivedRevenueMetrics), not real KPI
   documents. Kept here, away from that hook's heavy imports, so the editors and
   their tests can ask "is this one derived?" cheaply. The hook re-exports all of
   it, so existing imports from there keep working. */
export const AVG_DAILY_REVENUE_ID = "derived-avg-daily-revenue";
export const TECH_REVENUE_PER_HOUR_ID = "derived-tech-revenue-per-hour";
export const BEAT_YETI_RATE_ID = "derived-beat-yeti-rate";
export const DERIVED_METRIC_IDS = [
  AVG_DAILY_REVENUE_ID,
  TECH_REVENUE_PER_HOUR_ID,
  BEAT_YETI_RATE_ID,
];
export const isDerivedMetricId = (id) => DERIVED_METRIC_IDS.includes(id);

/**
 * Should a card's editor show the cross-workspace PAIRING builder (one metric
 * per team, combined into a column) instead of the plain metric list?
 *
 * Two or more workspaces → pairing. Except when one of the card's chosen
 * metrics is derived: a derived metric is a single figure over the whole scope
 * and cannot be paired, so the pairing builder has nothing true to say about it.
 * It used to show anyway — listing whichever metrics the workspaces happen to
 * share by name (Hours Worked) as if that were the card — and "Custom" would
 * then seed from them and overwrite the real metric.
 *
 * @param {string[]} workspaceIds  the card's tracked workspaces
 * @param {Array<{metricId?: string}>} rows  the card's chosen metric rows
 */
export const usesMetricPairing = (workspaceIds, rows) =>
  (workspaceIds || []).filter(Boolean).length >= 2
  && !(rows || []).some((r) => r && isDerivedMetricId(r.metricId));
